import React, { useEffect, useState } from "react";
import { Beat } from "../../../redux/reducers/spinner";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../redux/actions";
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { removePlusSign } from "../../helper/phoneNumber";

function ChangeUserPhone() {
  const dispatch = useDispatch();
  // let user = JSON.parse(localStorage.getItem("user"));
  const updating = useSelector((state) => state.users.updating);
  const { myProfile } = useSelector((state) => state.users);
  let userData = myProfile?.user;

  const [open, setOpen] = React.useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [phone, setPhone] = useState("");

  useEffect(() => {
    if (userData?.phone) {
      setPhone(userData?.phone);
    }
    // eslint-disable-next-line
  }, [userData?.phone]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);

    const cleanedPhone = removePlusSign(phone);

    // dispatch action to change phone
    dispatch(
      userActions.changeUserPhone({
        user_id: userData?.id,
        phone: cleanedPhone,
      })
    );
    handleClose();
  };

  return (
    <div>
      <MDBContainer>
        <MDBBtn color="primary" onClick={() => setOpen(true)}>
          Change Phone Number
        </MDBBtn>
        <MDBModal isOpen={open} toggle={handleClose}>
          <form name="form" onSubmit={handleSubmit}>
            <MDBModalHeader toggle={handleClose}>
              Change your Phone Number
            </MDBModalHeader>
            <MDBModalBody>
              <label htmlFor="phone">New Phone Number</label>
              <PhoneInput
                defaultCountry="NG"
                value={phone}
                onChange={setPhone}
                className={
                  "form-control form-control-rounded" +
                  (submitted && !phone ? " is-invalid" : "")
                }
              />
              {submitted && !phone && (
                <div className="invalid-feedback">
                  New Phone Number is required
                </div>
              )}
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={() => setOpen(false)}>
                Close
              </MDBBtn>
              <MDBBtn color="primary" type="submit">
                {updating === true ? <Beat loading={updating} /> : "Save"}
              </MDBBtn>
            </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    </div>
  );
}

export default ChangeUserPhone;
